import Payment from "../components/PaymentUzairAccount";

const ServerHostingPage = () => {
  const handleWhatsAppClick = (packageName) => {
    const message = encodeURIComponent(
      `Hi! I'm interested in the ${packageName} package. Could you please provide more details?`,
    );
    const phoneNumber = "+923124998010"; // Replace with actual WhatsApp number
    window.open(`https://wa.me/${phoneNumber}?text=${message}`, "_blank");
  };
  const packages = [
    {
      name: "ChatGPT API Keys",
      price: "$30",
      period: "/month",
      popular: false,
      color: "primary",
      features: [
        "Full API Access",
        "GPT-4 & GPT-3.5 Models",
        "Unlimited Requests",
        "24/7 Technical Support",
        "Regular Updates",
        "Documentation Included",
        "Pay As You Go",
      ],
    },
    {
      name: "Gemini API Keys",
      price: "$30",
      period: "/month",
      popular: false,
      color: "info",
      features: [
        "Full API Access",
        "Gemini Pro Models",
        "Multi-Modal Support",
        "High Performance",
        "24/7 Technical Support",
        "Documentation Included",
        "Flexible Integration",
      ],
    },
    {
      name: "ClickCease",
      price: "$75",
      period: "/month",
      popular: false,
      color: "warning",
      features: [
        "Click Fraud Protection",
        "Real-Time Monitoring",
        "Auto IP Blocking",
        "Detailed Analytics",
        "Multi-Platform Support",
        "Custom Rules Setup",
        "Priority Support",
      ],
    },
    {
      name: "Chatbot Solution",
      price: "$85",
      period: "/month",
      popular: false,
      color: "success",
      features: [
        "AI-Powered Chatbot",
        "Custom Training",
        "Multi-Language Support",
        "24/7 Availability",
        "CRM Integration",
        "Analytics Dashboard",
        "Unlimited Conversations",
        "Dedicated Support",
      ],
    },
    {
      name: "Patient Forms Email Integration",
      price: "$160",
      period: "/6 months",
      popular: false,
      color: "primary",
      features: [
        "Email Integration Setup",
        "Automated Patient Form Delivery",
        "Secure Data Handling",
        "Local Vendor Service",
        "Continuous Functionality",
        "Renewal Support",
      ],
    },
  ];

  return (
    <div
      style={{ fontFamily: "Arial, sans-serif", backgroundColor: "#f8f9fa" }}
    >
      {/* Header */}
      <header
        style={{
          backgroundColor: "#2c3e50",
          color: "white",
          padding: "60px 0",
        }}
      >
        <div className="container">
          <div className="row">
            <div className="col-12 text-center">
              <h1
                style={{
                  fontSize: "3rem",
                  fontWeight: "bold",
                  marginBottom: "20px",
                }}
              >
                Smart Tools Center
              </h1>
              <p style={{ fontSize: "1.2rem", opacity: 0.9 }}>
                All essential tools combined to improve efficiency and save
                money compared to marketplace offerings.
              </p>
            </div>
          </div>
        </div>
      </header>

      {/* Pricing Section */}
      <section style={{ padding: "80px 0", backgroundColor: "#f8f9fa" }}>
        <div className="container">
          <div className="row">
            <div className="col-12 text-center mb-5">
              <h2
                style={{
                  fontSize: "2.5rem",
                  fontWeight: "bold",
                  color: "#2c3e50",
                  marginBottom: "20px",
                }}
              >
                Choose Your Perfect Plan
              </h2>
              <p
                style={{
                  fontSize: "1.1rem",
                  color: "#6c757d",
                  maxWidth: "600px",
                  margin: "0 auto",
                }}
              >
                Select from our range of AI and digital marketing solutions
                designed to elevate your business
              </p>
            </div>
          </div>

          <div className="row justify-content-center">
            {packages.map((pkg, index) => (
              <div key={index} className="col-lg-3 col-md-6 mb-4">
                <div
                  className={`card h-100 ${
                    pkg.popular ? "border-success" : ""
                  }`}
                  style={{
                    boxShadow: pkg.popular
                      ? "0 10px 30px rgba(0,0,0,0.2)"
                      : "0 5px 15px rgba(0,0,0,0.1)",
                    border: pkg.popular
                      ? "3px solid #28a745"
                      : "1px solid #dee2e6",
                    transform: pkg.popular ? "scale(1.05)" : "scale(1)",
                    transition: "all 0.3s ease",
                  }}
                >
                  {pkg.popular && (
                    <div
                      style={{
                        backgroundColor: "#28a745",
                        color: "white",
                        textAlign: "center",
                        padding: "10px",
                        fontWeight: "bold",
                        fontSize: "0.9rem",
                      }}
                    >
                      MOST POPULAR
                    </div>
                  )}

                  <div className="card-body d-flex flex-column">
                    <div className="text-center mb-4">
                      <h3
                        style={{
                          fontSize: "1.5rem",
                          fontWeight: "bold",
                          color: "#2c3e50",
                          minHeight: "60px",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        {pkg.name}
                      </h3>
                      <div style={{ margin: "20px 0" }}>
                        <span
                          style={{
                            fontSize: "2.5rem",
                            fontWeight: "bold",
                            color: "#e74c3c",
                          }}
                        >
                          {pkg.price}
                        </span>
                        <span style={{ fontSize: "1.1rem", color: "#6c757d" }}>
                          {pkg.period}
                        </span>
                      </div>
                    </div>

                    <ul
                      className="list-unstyled flex-grow-1"
                      style={{ fontSize: "0.95rem" }}
                    >
                      {pkg.features.map((feature, idx) => (
                        <li
                          key={idx}
                          style={{
                            padding: "8px 0",
                            borderBottom: "1px solid #f8f9fa",
                          }}
                        >
                          <span
                            style={{ color: "#28a745", marginRight: "10px" }}
                          >
                            ✓
                          </span>
                          {feature}
                        </li>
                      ))}
                    </ul>

                    <button
                      className={`btn btn-${pkg.color} btn-lg w-100 mt-3`}
                      onClick={() => handleWhatsAppClick(pkg.name)}
                      style={{
                        fontWeight: "bold",
                        padding: "12px",
                        fontSize: "1rem",
                        transition: "all 0.3s ease",
                      }}
                      onMouseOver={(e) =>
                        (e.target.style.transform = "translateY(-2px)")
                      }
                      onMouseOut={(e) =>
                        (e.target.style.transform = "translateY(0)")
                      }
                    >
                      Get Started via WhatsApp
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section style={{ backgroundColor: "white", padding: "80px 0" }}>
        <div className="container">
          <div className="row">
            <div className="col-12 text-center mb-5">
              <h2
                style={{
                  fontSize: "2.5rem",
                  fontWeight: "bold",
                  color: "#2c3e50",
                  marginBottom: "20px",
                }}
              >
                Why Choose Our Services?
              </h2>
              <p
                style={{
                  fontSize: "1.1rem",
                  color: "#6c757d",
                  maxWidth: "700px",
                  margin: "0 auto",
                }}
              >
                We provide cutting-edge AI solutions and digital marketing tools
                to help your business grow
              </p>
            </div>
          </div>

          <div className="row">
            <div className="col-md-4 text-center mb-4">
              <div
                style={{
                  backgroundColor: "#3498db",
                  width: "80px",
                  height: "80px",
                  borderRadius: "50%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  margin: "0 auto 20px",
                  color: "white",
                  fontSize: "2rem",
                }}
              >
                🤖
              </div>
              <h4 style={{ color: "#2c3e50", marginBottom: "15px" }}>
                Advanced AI Technology
              </h4>
              <p style={{ color: "#6c757d" }}>
                Access to the latest ChatGPT and Gemini AI models with seamless
                integration and unlimited possibilities.
              </p>
            </div>

            <div className="col-md-4 text-center mb-4">
              <div
                style={{
                  backgroundColor: "#2ecc71",
                  width: "80px",
                  height: "80px",
                  borderRadius: "50%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  margin: "0 auto 20px",
                  color: "white",
                  fontSize: "2rem",
                }}
              >
                🔒
              </div>
              <h4 style={{ color: "#2c3e50", marginBottom: "15px" }}>
                Fraud Protection & Security
              </h4>
              <p style={{ color: "#6c757d" }}>
                Enterprise-grade click fraud protection and secure API access to
                safeguard your business investments.
              </p>
            </div>

            <div className="col-md-4 text-center mb-4">
              <div
                style={{
                  backgroundColor: "#f39c12",
                  width: "80px",
                  height: "80px",
                  borderRadius: "50%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  margin: "0 auto 20px",
                  color: "white",
                  fontSize: "2rem",
                }}
              >
                💬
              </div>
              <h4 style={{ color: "#2c3e50", marginBottom: "15px" }}>
                24/7 Expert Support
              </h4>
              <p style={{ color: "#6c757d" }}>
                Dedicated support team available round-the-clock via WhatsApp to
                assist with setup and technical queries.
              </p>
            </div>
          </div>

          <div className="row mt-4">
            <div className="col-md-4 text-center mb-4">
              <div
                style={{
                  backgroundColor: "#e74c3c",
                  width: "80px",
                  height: "80px",
                  borderRadius: "50%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  margin: "0 auto 20px",
                  color: "white",
                  fontSize: "2rem",
                }}
              >
                ⚡
              </div>
              <h4 style={{ color: "#2c3e50", marginBottom: "15px" }}>
                Quick Setup
              </h4>
              <p style={{ color: "#6c757d" }}>
                Get started within minutes with our easy integration process and
                comprehensive documentation.
              </p>
            </div>

            <div className="col-md-4 text-center mb-4">
              <div
                style={{
                  backgroundColor: "#9b59b6",
                  width: "80px",
                  height: "80px",
                  borderRadius: "50%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  margin: "0 auto 20px",
                  color: "white",
                  fontSize: "2rem",
                }}
              >
                💰
              </div>
              <h4 style={{ color: "#2c3e50", marginBottom: "15px" }}>
                Affordable Pricing
              </h4>
              <p style={{ color: "#6c757d" }}>
                Competitive monthly rates with no hidden fees. Pay only for what
                you need with flexible billing.
              </p>
            </div>

            <div className="col-md-4 text-center mb-4">
              <div
                style={{
                  backgroundColor: "#1abc9c",
                  width: "80px",
                  height: "80px",
                  borderRadius: "50%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  margin: "0 auto 20px",
                  color: "white",
                  fontSize: "2rem",
                }}
              >
                📊
              </div>
              <h4 style={{ color: "#2c3e50", marginBottom: "15px" }}>
                Real-Time Analytics
              </h4>
              <p style={{ color: "#6c757d" }}>
                Detailed insights and analytics dashboards to track performance
                and optimize your campaigns.
              </p>
            </div>
          </div>
        </div>
      </section>

      <Payment />

      <link
        href="https://cdnjs.cloudflare.com/ajax/libs/bootstrap/5.3.0/css/bootstrap.min.css"
        rel="stylesheet"
      />
    </div>
  );
};

export default ServerHostingPage;
